<template>


  <div ref="keyword" class="keyword"
    @mousedown="dragStart"
    :class="{isNew: keyword.isNew, active, empty: !this.keyword.value}"
    :style="style">
    <div class="tools">
      <i @click.prevent="destroy" class="fa fa-close"></i>
    </div>

    <i class="resize-handle icon mdi mdi-texture" @mousedown.prevent.stop="resizeStart"></i>

    <input
      @click="focus"
      @change="change"
      ref="input"
      v-model="keyword.value" />
  </div>



</template>


<script>
import Vue from 'vue'
import _ from 'underscore'
// import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  components: {},
  props: ['keyword', 'scale', 'onDelete', 'onUpdate', 'onClick', 'activeKeywordId'],
  mounted() {
    if( !this.keyword) return;

    // When creating a new one, focus the input
    if(this.activeKeywordId === parseInt(this.keyword.id)) {
      this.$refs.input.focus();
    }
  },

  methods: {
    beforeDestroy() {
      this.clearListeners();
    },

    change() {
      // This actually isn't needed since we're using v-model
      // as long as the keyword has a keyword.value prop the changes
      // will be reactive.
      // console.log(`keyword value changed to ${this.keyword.value}`)
      // this.onUpdate(this.keyword.id, {
      //   value: this.keyword.value,
      // })
    },

    focus() {
      // console.log('focus()')
      this.onClick(this.keyword);
    },

    destroy() {
      this.onDelete(this.keyword);
    },

    resizeStart(e) {
      // Absolute window location
      const resizeCoords = {
        absoluteStartX: e.pageX,
        absoluteStartY: e.pageY,
      };

      // Set end values as well so we avoid nulls/NaNs
      Object.assign(resizeCoords, {
        absoluteEndX: resizeCoords.absoluteStartX,
        absoluteEndY: resizeCoords.absoluteStartY,
      })

      this.resizeCoords = resizeCoords;

      $(window).on('mousemove.imageKeyword', this.resizeMove);
      $(window).on('mouseup.imageKeyword', this.resizeEnd);
    },

    resizeMove(e) {
      if( !this.resizeCoords) return;
      Vue.set(this.resizeCoords, 'absoluteEndX', e.pageX);
      Vue.set(this.resizeCoords, 'absoluteEndY', e.pageY);
    },

    // Save
    resizeEnd(e) {
      const width = `${this.style.width}`.replace('px', '') / this.scale;
      const height = `${this.style.height}`.replace('px', '') / this.scale;

      // console.log(newX, newY)
      this.onUpdate(this.keyword.id, { width, height })

      this.resizeCoords = null;
      this.clearListeners();
    },

    // Dragging
    dragStart(e) {
      // Absolute window location
      const dragCoords = {
        absoluteStartX: e.pageX,
        absoluteStartY: e.pageY,
      };

      // Set end values as well so we avoid nulls/NaNs
      Object.assign(dragCoords, {
        absoluteEndX: dragCoords.absoluteStartX,
        absoluteEndY: dragCoords.absoluteStartY,
      })

      this.dragCoords = dragCoords;

      $(window).on('mousemove.imageKeyword', this.dragMove);
      $(window).on('mouseup.imageKeyword', this.dragEnd);
    },

    // Dragging - track how far the mouse has moved
    dragMove(e) {
      if( !this.dragCoords) return;
      Vue.set(this.dragCoords, 'absoluteEndX', e.pageX);
      Vue.set(this.dragCoords, 'absoluteEndY', e.pageY);
    },

    // Save
    dragEnd(e) {
      const newX = `${this.style.left}`.replace('px', '') / this.scale;
      const newY = `${this.style.top}`.replace('px', '') / this.scale;

      // console.log(newX, newY)
      this.onUpdate(this.keyword.id, { x: newX, y: newY })

      this.dragCoords = null;
      this.clearListeners();
    },

    clearListeners() {
      $(window).off('mousemove.imageKeyword');
      $(window).off('mouseup.imageKeyword');
    },

  },

  computed: {



    style() {
      const style = {
        left:     this.keyword.x,
        top:      this.keyword.y,
        width:    this.keyword.width,
        height:   this.keyword.height,
      }

      // Scale the styles
      for(let prop in style) style[prop] = style[prop] * this.scale;

      /**
       * ========== DRAGGING ==========
       */

      if(this.dragCoords) {
        const {
          absoluteStartX, absoluteStartY, absoluteEndX, absoluteEndY,
        } = this.dragCoords;
        const distX = (absoluteEndX - absoluteStartX);
        const distY = (absoluteEndY - absoluteStartY);
        const $img = $('.image-container img');
        const $keyword = $(this.$refs.keyword);


        // X
        const minLeft = 0;
        const maxLeft = $img.width() - $keyword.width();
        style.left += distX;
        if(style.left > maxLeft) {
          // console.log(`too far right: ${style.left}. max is ${maxLeft}`)
          style.left = maxLeft;
        } else if(style.left < minLeft) {
          // console.log('too far left: '+style.left)
          style.left = minLeft;
        }

        // Y
        const minTop = 0;
        const maxTop = $img.height() - $keyword.height();
        style.top += distY;
        if(style.top > maxTop) {
          // console.log(`too far down: ${style.top}. max is ${maxTop}`)
          style.top = maxTop;
        } else if(style.top < minTop) {
          // console.log('too far up: '+style.top)
          style.top = minTop;
        }



      /**
       * ========== RESIZING ==========
       */

      } else if(this.resizeCoords) {

        const {
          absoluteStartX, absoluteStartY, absoluteEndX, absoluteEndY,
        } = this.resizeCoords;
        const distX = (absoluteEndX - absoluteStartX);
        const distY = (absoluteEndY - absoluteStartY);
        const $img = $('.image-container img');
        const $keyword = $(this.$refs.keyword);


        // Width
        const minWidth = 10;
        const maxWidth = ($img.offset().left + $img.width()) - ($keyword.offset().left);
        style.width += distX;
        if(style.width > maxWidth) {
          // console.log(`too thick: ${style.width}. max is ${maxWidth}`)
          style.width = maxWidth;
        } else if(style.width < minWidth) {
          // console.log('too thin: '+style.width)
          style.width = minWidth;
        }

        // Height
        const minHeight = 15;
        const maxHeight = ($img.offset().top + $img.height()) - ($keyword.offset().top);
        style.height += distY;
        if(style.height > maxHeight) {
          // console.log(`too tall: ${style.height}. max is ${maxHeight}`)
          style.height = maxHeight;
        } else if(style.height < minHeight) {
          // console.log('too short: '+style.height)
          style.height = minHeight;
        }

      } // Finish movement mods



      // Add "px" suffix
      for(let prop in style) style[prop] = `${style[prop]}px`;
      return style;
    },

    active() {
      if(_.isUndefined(this.activeKeywordId)) return false;
      if(parseInt(this.activeKeywordId) === parseInt(this.keyword.id)) return true;
    },
  },

  data() {
    return {
      dragCoords: null,
      resizeCoords: null,
    }
  },

}
</script>


<!-- Scoped styling -->
<style lang="scss" scoped>

  .keyword {
    position: absolute;
    z-index: 10;
    border: 1px solid black;
    box-sizing: content-box; /* ** this is very important to make position calcs work ** */

    // background: orange;
    // padding: 3px 5px;
    // border-radius: 4px;



    .tools {
      display: none;
      position: absolute;
      background: #FBBC05;
      width: 100%;
      height: 20px;
      top: -20px;
      text-align: right;
      border: 1px solid black;
      border-width: 1px 1px 0 1px;
      border-bottom: 1px solid #333;

      i {
        cursor: pointer;
        // background: green;
        padding: 2px 4px;
      }
    }

    .resize-handle {
      cursor: nwse-resize;
      position: absolute;
      bottom: 0; right: 0;
      z-index: 100;
    }

    input {
      display: block;
      position: absolute;
      width: 100%;
      top: 0; left: 0; bottom: 0; right: 0;
      cursor: pointer;
      text-align: center;
      background: #fcd45e;
      border: none;
    }

    &.isNew {
      z-index: 101;
      pointer-events: none;
      opacity: 0.5;

      .resize-handle {
        display: none;
      }
    }

    &.active {
      z-index: 100;
      -webkit-box-shadow: -1px 0px 25px -3px rgba(0,0,0,0.54);
      -moz-box-shadow: -1px 0px 25px -3px rgba(0,0,0,0.54);
      box-shadow: -1px 0px 25px -3px rgba(0,0,0,0.54);

      .tools {
        display: block;
      }

      input {
        opacity: 0.82;
        // background-color: orange;
      }
    }

    &.empty {
      input {
        opacity: 0.8;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// ImageKeyword.vue?23eb1432